
<div class="screen-booking">
  <div class="popup-aside-plain">
    <div class="popup-takeResa">
      <div style="text-align:center">{{ getAllInfos.restoName }}</div>
      <div style="font-weight:100; font-size:14px">
        <div style="text-align:center">{{ getAllInfos.restoAdresse }}</div>
        <div style="text-align:center"><a :href="'tel:' + getAllInfos.restoTel">{{ getAllInfos.restoTel }}</a></div>
      </div>
    </div>
    <div class="change-container" v-loading="loading">
      <!-- START Screen -->
      <div class="change-content" v-if="getCurrentResa !== undefined && getStep === 'START'">
        <div class="change-wylike">Souhaitez vous<br> modifier ou annuler<br> la réservation suivante :</div>
        <div class="change-infos">
          <div>{{ getCurrentResa.dateResa.labelDay }} {{ getCurrentResa.dateResa.label }} {{
            getCurrentResa.dateResa.labelMonth }} {{ getCurrentResa.dateResa.year }}</div>
          <div>à {{ getCurrentResa.hour }}</div>
          <div>pour {{ getCurrentResa.nbCouvert }} couverts</div>
        </div>
        <el-row v-if="getIfCancelable" class="black-inputs change-btns">
          <el-col :span="9" :offset="2">
            <el-button class="red" type="primary" @click="cancelResa">Annuler</el-button>
          </el-col>
          <el-col :span="9" :offset="2">
            <el-button type="primary" @click="modifyResaCall">Modifier</el-button>
          </el-col>
        </el-row>
        <el-row v-else-if="getLimitHours" class="black-inputs change-btns">
          Vous ne pouvez modifier ou annuler la réservation,<br>
          {{ getLimitHours.hours }}H avant le début de celle-ci.
        </el-row>
      </div>

      <!-- NOTHING Screen -->
      <div class="change-content" v-if="getStep === 'NOTHING'">
        La réservation ne semble plus d'actualité,<br>
        nous vous conseillons de contacter directement le restaurant<br><br>
        <div style="text-align:center"><a :href="'tel:' + getAllInfos.restoTel">{{ getAllInfos.restoTel }}</a></div>
        <div style="text-align:center"><a :href="'mailto:' + getAllInfos.restoMail">{{ getAllInfos.restoMail }}</a>
        </div>
        <br>
        Bonne journée de la part de Resa Ninja
      </div>

      <!-- CANCEL_DONE Screen -->
      <div class="change-content" v-if="getStep === 'CANCEL_DONE'">
        <div>
          Nous avons bien pris en compte votre demande d'annulation,<br>
          l'information a été transmise au restaurateur.<br>
          Bonne journée de la part de Resa Ninja
        </div>
      </div>

      <!-- CANCEL_DONE Screen -->
      <div class="change-content" v-if="getStep === 'MODIFY_DONE'">
        <div>
          Nous avons bien pris en compte votre demande de modification,<br>
          l'information a été soumise à validation au restaurateur.<br>
          Bonne journée de la part de Resa Ninja
        </div>
      </div>

      <!-- MODIFY screen -->
      <div class="change-content" v-if="getStep === 'MODIFY'">
        <el-row :class="'black-inputs'">
          <el-col :span="18" :offset="3">
            <el-form ref="formModify.data" :model="formModify.data" label-width="120px">
              <el-form-item>
                <calendar-nav :checkVisibility="true" />
              </el-form-item>
              <el-form-item v-if="getCurrentResa.type !== 'prepaiement'">
                <el-input-number class="text-centered" size="medium"
                  :min="this.getSelectedMainServiceData.nbMinByResa"
                  :max="this.getSelectedMainServiceData.nbMaxByResa" v-model="formModify.data.nbCouvert"
                  @change="nbCouvUpdate"></el-input-number>
              </el-form-item>
              <el-form-item v-loading="loadingHours">
                <div class="popup-takeResa-dayClosed" v-if="getServicesHours === null && !complet">Fermé</div>
                <div class="popup-takeResa-dayClosed" v-if="complet">Complet</div>
                <div class="popup-takeResa-dayClosed" v-if="allServiceIsLock && !limitInterval">Service fermé</div>
                <div class="popup-takeResa-dayClosed" v-if="allServiceIsLock">Fermeture exceptionnelle</div>
                <el-select v-if="getServicesHours !== null && !complet && !allServiceIsLock" class="text-centered"
                  v-model="formModify.data.date2" value-key="id" placeholder="Choisissez une heure">
                  <el-option-group v-for="ms in getServicesHoursData" :key="ms.label" :label="ms.label"
                    v-if="ms.tab.length > 0">
                    <el-option v-for="h in ms.tab" :key="h.id" :label="h.hour" :value="h">
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input v-model="formModify.data.commentResa" :autosize="{ minRows: 3 }" type="textarea"
                  placeholder="Ajouter un commentaire"></el-input>
              </el-form-item>
              <div v-loading="loadingTakeResa">
                <el-form-item>
                  <el-row :gutter="20">
                    <el-col :span="24">
                      <el-button v-if="!loadingTakeResa && !complet && !allServiceIsLock && formModify.data.date2"
                        :disabled="btnModifyDisabled" type="primary"
                        @click="validModification('formModify.data')">Modifier</el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
              </div>
            </el-form>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</div>
